import {
  HttpInterceptorFn,
  HttpErrorResponse,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

const PUBLIC_ENDPOINTS: readonly string[] = [
  '/login',
  '/refresh',
  '/jwt',
  '/jwt-get',
  '/jwt-select-company',
];

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse)) {
        return throwError(() => error);
      }

      if (PUBLIC_ENDPOINTS.some((pattern) => req.url.includes(pattern))) {
        return throwError(() => error);
      }

      if (error.status === 401) {
        return authService.handle401Error(req, next);
      }

      return throwError(() => error);
    }),
  );
};
